export default function TradebookGroup({ groupedTrades }) {
  return (
    <div className="space-y-4">
      {groupedTrades.map(group => (
        <div
          key={group[0].tradingsymbol}
          className="rounded-xl border border-border bg-card"
        >
          {/* Instrument header */}
          <div className="px-4 py-2 font-semibold text-orange-400 border-b border-border">
            {group[0].tradingsymbol}
          </div>

          <table className="w-full text-sm">
            <tbody>
              {group.map(trade => (
                <tr key={trade.trade_id} className="border-b border-border/50">
                  <td className="py-3 px-4 text-center">
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-semibold
                        ${
                          trade.side === "BUY"
                            ? "bg-emerald-500/20 text-emerald-400"
                            : "bg-red-500/20 text-red-400"
                        }`}
                    >
                      {trade.side}
                    </span>
                  </td>

                  <td className="py-3 px-4 text-right">{trade.qty}</td>

                  <td className="py-3 px-4 text-right">₹{trade.price}</td>

                  <td className="py-3 px-4 text-right text-muted-foreground text-xs">
                    {trade.iso_date
                      ? trade.iso_date.slice(11, 19)
                      : "--"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
